import { postData } from "./util";
// Expose helper globally for inline scripts in Twig templates

import "../css/app.scss";
import "@fortawesome/fontawesome-free/css/all.min.css";

document.addEventListener("DOMContentLoaded", () => {
  // Logout listener
  const logOutBtn = document.querySelector(".log-out-btn");
  logOutBtn?.addEventListener("click", async (e) => {
    e.preventDefault();

    try {
      await postData("/api/signout", {});
    } catch (error) {
      console.error("Logout failed:", error);
    } finally {
      window.location.href = "/";
    }
  });

  // Remove unwanted tooltips
  document.querySelectorAll("[data-tooltip]").forEach((tooltipTrigger) => {
    const truncatedEl = tooltipTrigger.classList.contains("truncate")
      ? tooltipTrigger
      : tooltipTrigger.querySelector(".truncate");

    if (!truncatedEl) return;

    if (truncatedEl.scrollWidth <= truncatedEl.clientWidth) {
      const tooltipId = tooltipTrigger.getAttribute("data-tooltip");
      const tooltipEl = document.querySelector(tooltipId);
      tooltipEl?.remove();
      tooltipTrigger.removeAttribute("data-tooltip");
    }
  });
});
